import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import WalletCover from '../../assets/target/images/WalletCover.png';
import Card from '../../components/Card';
import CardActions from '../../components/CardActions/CardActions';
import HistoryBlock from '../../components/HistoryBlock';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import HelperService from '../../services/HelperService';
import { cardSlice } from '../../store/slices';

import './CardPage.scss';

const { routes } = AppConfig;

const CardPage = ({ cardInfo }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		if (location.pathname !== routes.mainPage) {
			dispatch(cardSlice.actions.setViewedCardDetails());
		}
	}, [location]);

	const goToCardDetails = () =>
		navigate(
			{ pathname: routes.cardDetails },
			{
				state: {
					cardInfo,
				},
			}
		);

	return (
		<div className='CardPage'>
			<PageHeader header='Design card' collapsed />
			<img className='CardPage__background' src={WalletCover} alt='Wallet background' />
			<div className='CardPage__balance-block'>
				<div className='CardPage__balance-title'>{cardInfo?.Label}</div>
				<div className='CardPage__balance'>$ {HelperService.FormatFiatWithoutCurrency(cardInfo?.BalanceUsd)}</div>
			</div>
			<Card
				color={cardInfo.Color}
				Id={cardInfo.Id}
				number={cardInfo.Number}
				cardholderName={cardInfo.CardholderName}
				paymentSystem={cardInfo.PaymentSystem}
				status={cardInfo.Status}
				onClick={goToCardDetails}
			/>
			<div className='CardPageMainBlock'>
				<CardActions cardInfo={cardInfo} />
			</div>
			<HistoryBlock cardId={cardInfo.Id} />
		</div>
	);
};

export default CardPage;
